import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import { nonAuthInstance } from "../../services/axiosConfig";
import { isObject, split } from "lodash";

export default function UserDashboard() {
    const { auth } = useAuth();
    const adminOrgId = sessionStorage.getItem("adminOrgId");

    const initialCond = {
        sourceUser: "",
        orgId: adminOrgId,
    };

    const initialStats = [
        { id: "user_total_cnt", name: "전체 회원권", value: "15,000", unit: "장" },
        { id: "user_use_cnt", name: "미사용 회원권", value: "0", unit: "장" },
        { id: "user_remain_cnt", name: "사용된 회원권", value: "0", unit: "장" },
        { id: "total_cnt", name: "전체 회원권", value: "0", unit: "장" },
        { id: "publish_cnt", name: "발행 회원권", value: "0", unit: "장" },
        { id: "remain_cnt", name: "잔여 회원권", value: "0", unit: "장" },
    ];

    const [cond, setCond] = useState(initialCond);
    const [stats, setStats] = useState(initialStats);

    useEffect(() => {
        console.log("useEffect auth", auth);
        let condTmp = cond;
        condTmp.sourceUser = auth.admin_seq;
        // console.log("condTmp==>", condTmp);
        couponCount(condTmp);
        setCond(condTmp);
    }, []);

    /**
     * 쿠폰 개수 카운트
     * @returns
     */
    const couponCount = async (condTmp) => {
        try {
            const response = await nonAuthInstance.post("coupon/totalCount", condTmp);
            if (response.status === 200 && response.data) {
                console.log("response.data: ", response.data);
                // console.log("🚀 ~ couponCount ~ isArray(response.data):", isObject(response.data));
                if (isObject(response.data)) {
                    const dataKeys = Object.keys(response.data);
                    console.log("🚀 ~ couponCount ~ dataKeys:", dataKeys);
                    dataKeys.map((item) => {
                        updateCountValue(item, response.data[item]);
                    });
                }
            } else {
            }
        } catch (e) {
            console.log("e===>", e);
        }
    };

    const updateCountValue = (id, newVal) => {
        setStats((prevData) => prevData.map((item) => (item.id === id ? { ...item, value: newVal } : item)));
    };

    return (
        <>
            <main>
                <h3 className="text-2xl font-semibold leading-6 text-gray-900">S휴먼헬스케어 환영합니다!</h3>
                <div className="mt-5 grid grid-cols-1 gap-2 rounded-2xl py-4">
                    <div className="py-4 bg-gray-900 rounded-2xl">
                        {/* Stats */}
                        <span className="ml-4 text-xl font-semibold leading-10 text-white">회원권</span>
                        <div className="bg-gray-900 rounded-2xl gap-0.5 overflow-hidden text-left grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
                            {stats.map(
                                (stat, statIdx) =>
                                    split(stat.id, "_")[0] !== "user" && (
                                        <div key={statIdx} className={"sm:border-l border-t border-white/5 py-6 px-4 sm:px-6 lg:px-8"}>
                                            <p className="text-sm font-medium leading-6 text-gray-400">{stat.name}</p>
                                            <p className="mt-2 flex items-baseline gap-x-2 ">
                                                <span className="text-4xl font-semibold tracking-tight text-white">{stat.value}</span>
                                                <span className="text-sm text-gray-400">{stat.unit}</span>
                                            </p>
                                        </div>
                                    )
                            )}
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}
